import React from 'react'
import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'
import { Select, SelectItem } from '@nextui-org/react'
import { useGameplayContext, IGameplayContext } from '@/contexts/gameplayContext'
import { UPGRADES } from '@/constants/upgrades'
import { UpgradeBoardEnum, UpgradeHousingEnum } from '@/types'

export const MiniEquipmentCard: React.FC = () => {
  const { gameData, changeEquipment } = useGameplayContext() as IGameplayContext

  const ownedSurfboards = Object.values(UPGRADES).filter(
    (upgrade) => upgrade.category === 'surfboards' && gameData.upgrades[upgrade.key]?.isPurchased
  )

  const housingUpgrades = Object.values(UPGRADES).filter(
    (upgrade) => upgrade.category === 'housing' && gameData.upgrades[upgrade.key]?.isPurchased
  )

  const handleBoardChange = (key: UpgradeBoardEnum) => {
    changeEquipment('surfboard', key)
  }

  const handleHousingChange = (key: UpgradeHousingEnum) => {
    changeEquipment('housing', key)
  }

  return (
    <div className="bg-white rounded-lg p-4 shadow-lg h-full flex flex-col">
      <div className="grid grid-cols-2 gap-3">
        <div className="bg-blue-50 rounded p-2">
          <div className="flex items-center mb-1">
            <span className="text-xl mr-1">🏄‍♂️</span>
            <span className="text-sm font-medium">Surfboard</span>
          </div>
          <Select
            selectedKeys={gameData.equipment.surfboard ? [gameData.equipment.surfboard] : []}
            onSelectionChange={(keys) => handleBoardChange(Array.from(keys)[0] as UpgradeBoardEnum)}
            size="sm"
            aria-label="Select Surfboard"
            classNames={{
              base: 'min-h-0',
              trigger: 'min-h-0 h-7 py-0',
              value: 'text-tiny'
            }}
          >
            {ownedSurfboards.map((board) => (
              <SelectItem key={board.key} value={board.key} textValue={board.name}>
                <div className="text-tiny">{board.name}</div>
              </SelectItem>
            ))}
          </Select>
        </div>

        <div className="bg-stone-50 rounded p-2">
          <div className="flex items-center mb-1">
            <span className="text-xl mr-1">🏠</span>
            <span className="text-sm font-medium">Housing</span>
          </div>
          <Select
            selectedKeys={gameData.equipment.housing ? [gameData.equipment.housing] : []}
            onSelectionChange={(keys) => handleHousingChange(Array.from(keys)[0] as UpgradeHousingEnum)}
            size="sm"
            aria-label="Select Housing"
            classNames={{
              base: 'min-h-0',
              trigger: 'min-h-0 h-7 py-0',
              value: 'text-tiny'
            }}
          >
            {housingUpgrades.map((house) => (
              <SelectItem key={house.key} value={house.key} textValue={house.name}>
                <div className="text-tiny">{house.name}</div>
              </SelectItem>
            ))}
          </Select>
        </div>
      </div>

      <div className="text-center mt-auto pt-1">
        <Link
          to="/upgrades"
          className="text-sm text-blue-600 hover:text-blue-800 font-medium flex items-center justify-center"
        >
          More equipment
          <ChevronRight className="w-4 h-4 ml-1" />
        </Link>
      </div>
    </div>
  )
}
